import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../../components/styles/CardGenerator.css';
import cardLogo from '../../img/vipe-card-logo.png';
import wordingLogo from '../../img/wording-card-logo.png';
import hands from '../../img/hands.png';
import phone from '../../img/phone-icon.png';
import '../styles/PreviewPage.css';
import '../styles/FormHeader.css';
import FormLogo from './components/FormLogo';
import FormFoot from './components/FormFoot';

const PreviewPage = ({ formData, language, onClose, onNextPage}) => {
  const { t } = useTranslation();
  const marginLeft = language === 'en' ? '223px' : '217px';

  const [logos, setLogos] = useState([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const response = await fetch(`https://vipe.uy/services/get_sponsors.php?`)
        const data = await response.json();
        setLogos(data.logos);
      } catch (error) {
      }
    };

    fetchLogos();
  }, []);

  function getCurrentDate() {
    const currentDate = new Date();
    return `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
  }

  function insertLineBreaks(text) {
    const regex = new RegExp(`.{1,${40}}`, 'g');
    const lines = text.match(regex);

    if (lines) {
      return lines.join('<br>');
    } else {
      return text;
    }
  }

  formData.date = getCurrentDate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await fetch(`https://vipe.uy/services/visit_log.php?`)
    } catch (error) {
    }
    onNextPage();
  };

  return (
    <>
    <div className='preview'>
      <FormLogo />
      <div className='atention-data'>
        <p>{t('wordings.previewAtention1')}</p>
        <p style={{marginBottom: '25px'}}>{t('wordings.previewAtention2')}</p>
        <p>{t('wordings.previewAtention3')}</p>
      </div>
      <div id="page" className="page">

        <div className='card-row solo-web'>

          <div className="card">
            <div className="front">
              <div className="card-title">
                <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
              </div>
              <div className="name">
                {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
              </div>
              <div className="country-identityDocument">
                <div className="country">{formData.country}</div>
                <div className="identityDocument">{formData.identityDocument}</div>
              </div>
              <div className='medical-emergency'>
                <div className='health-service'>{formData.healthServiceProvider}</div>
                <div className='emergency-service'>{formData.emergencyMedicalService}</div>
              </div>
              <div className="date-blood">
                <div className="dateOfBirth">
                  <div className="pBirth">{t('card.birth')}</div>
                  <div className="birthValue">{formData.dateOfBirth}</div>
                </div>
                <div className="bloodGroup">
                  <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                  <div className="bloodGroupValue">{formData.bloodGroup}</div>
                </div>
                <div className="preferredHand">
                  {/* Mano izquierda */}
                  <label>
                    <input
                      className="check-hand"
                      type="checkbox"
                      name="hand"
                      value="left"
                      checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                      readOnly
                    />
                  </label>
                  <img src={hands} alt="Both hands" className="hand-image"/>
                    {/* Mano derecha */}
                  <label>
                    <input
                      className="check-hand"
                      type="checkbox"
                      name="hand"
                      value="right"
                      checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                      readOnly
                    />
                  </label>
                </div>
              </div>
              <div className='phone-promo'>
              <div className="phone-div">
                <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                <div className='phoneValues'>
                {formData.phones.map((phoneNumber, index) => (
                  <div key={index}>{phoneNumber}</div>
                ))}
                </div>
              </div>
                <div className='promoCode-div'>
                <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                    <div className='promoCodeValue'>
                      {logos.map((logo, index) => {
                        if (formData.promotionalCode === logo.empresaMostrar) {
                          return (
                            <div key={index} className='promoCodeValue'>
                              <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card">
            <div className="back">
              <div className="card-title">
                <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
              </div>
              <div className='back-form-data'>
                <div className='conditions-commentary'>
                  <div className='conditions'>
                    {formData.conditions.map((condition, index) => (
                        <div key={index} className="disease">
                        <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                        {condition.medication && (
                          <div className="medication">
                            <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                            <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                            <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                            <div className='frequency'>
                              {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className='commentary-div'>
                    <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                    <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                  </div>
                </div>
                <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
              </div>
            </div>
          </div>

        </div>
        <div className='forMobileCards'>
          {/* <div className='solo-mobile anversoWording'><p>{t('wordings.anverso')}</p></div> */}
          <div className='card-row solo-mobile'>
            
            <div className="card">
              <div className="front">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className="name">
                  {formData.name.toUpperCase()} {formData.lastName.toUpperCase()}
                </div>
                <div className="country-identityDocument">
                  <div className="country">{formData.country}</div>
                  <div className="identityDocument">{formData.identityDocument}</div>
                </div>
                <div className='medical-emergency'>
                  <div className='health-service'>{formData.healthServiceProvider}</div>
                  <div className='emergency-service'>{formData.emergencyMedicalService}</div>
                </div>
                <div className="date-blood">
                  <div className="dateOfBirth">
                    <div className="pBirth">{t('card.birth')}</div>
                    <div className="birthValue">{formData.dateOfBirth}</div>
                  </div>
                  <div className="bloodGroup">
                    <div className="pBloodGroup">{t('card.bloodGroup')}</div>
                    <div className="bloodGroupValue">{formData.bloodGroup}</div>
                  </div>
                  <div className="preferredHand">
                    {/* Mano izquierda */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="left"
                        checked={formData.preferredHand === 'Izquierda' || formData.preferredHand === 'Left'}
                        readOnly
                      />
                    </label>
                    <img src={hands} alt="Both hands" className="hand-image"/>
                      {/* Mano derecha */}
                    <label>
                      <input
                        className="check-hand"
                        type="checkbox"
                        name="hand"
                        value="right"
                        checked={formData.preferredHand === 'Derecha' || formData.preferredHand === 'Right'}
                        readOnly
                      />
                    </label>
                  </div>
                </div>
                <div className='phone-promo'>
                <div className="phone-div">
                  <div className='phone-image'><img src={phone} alt='phoneImage' className='phone-image' /></div>
                  <div className='phoneValues'>
                  {formData.phones.map((phoneNumber, index) => (
                    <div key={index}>{phoneNumber}</div>
                  ))}
                  </div>
                </div>
                  <div className='promoCode-div'>
                  <div className='wording-promoCode'>{formData.promotionalCode ? t('card.courtesy') : null}</div>
                      <div className='promoCodeValue'>
                        {logos.map((logo, index) => {
                          if (formData.promotionalCode === logo.empresaMostrar) {
                            return (
                              <div key={index} className='promoCodeValue'>
                                <img src={`data:image/png;base64,${logo.rutaImagen}`} alt={logo.empresaMostrar} className='promoCodeValue'/>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          {/* <div className='reverseWording'>{t('wordings.reverse')}</div> */}
          <div className='card-row solo-mobile'>

            <div className="card">
              <div className="back">
                <div className="card-title">
                  <img src={cardLogo} alt='logo-title' className='card-title-logo' />
                  <img src={wordingLogo} alt='wording-title' className='card-title-wording' />
                </div>
                <div className='back-form-data'>
                  <div className='conditions-commentary'>
                    <div className='conditions'>
                      {formData.conditions.map((condition, index) => (
                          <div key={index} className="disease">
                          <div className="diseaseName">{condition.diseaseName.toUpperCase()}</div>
                          {condition.medication && (
                            <div className="medication">
                              <div className='medicationName'>{condition.diseaseName ? condition.medication.medicationName : null}</div>

                              <div className='separator-div'>{condition.diseaseName && condition.medication.medicationName ? '/' : null}</div>

                              <div className='dosage'>{condition.diseaseName ?  condition.medication.dosage : null}</div>

                              <div className='separator-div'>{condition.diseaseName && condition.medication.dosage ? '/' : null}</div>

                              <div className='frequency'>
                                {condition.diseaseName && condition.medication.frequency ? `${condition.medication.frequency} / ${t('card.day')}` : ''}
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className='commentary-div'>
                      <div className='wording-commentary'>{t('card.commentaryDot')}</div>
                      <div className='commentaryValue' dangerouslySetInnerHTML={{ __html: insertLineBreaks(formData.commentary) }} />
                    </div>
                  </div>
                  <div className='card-footer' style={{marginLeft}}>{t('card.emision')} {formData.date}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className='print-preview-information'>
        <p style={{fontWeight: 'bold'}}>{t('wordings.previewAtention7')}</p>
        <p>{t('wordings.previewAtention4')}</p>
        <p>{t('wordings.previewAtention5')}</p>
        <p style={{fontWeight: 'bold'}}>{t('wordings.previewAtention6')}</p>
      </div>
      <div className='next-back-div-prev'>
          <button className='square-button-back'onClick={onClose}>
          <span className="button-text">{t('form.previous')}</span>
          </button>
        <button className='square-button-next'
         onClick={handleSubmit}
         >
          <span className="button-text">{t('form.confirmData')}</span>
        </button>
      </div>
      
    </div>
    <FormFoot language={language} />
    </>
    );
};

export default PreviewPage;
